UAEditUserInfoCtrl.$inject = ['user', 'adminApi', '$uibModalInstance', 'timezones']

export default function UAEditUserInfoCtrl(user, adminApi, $modalInstance, timezones) {
  this.userInfo = {
    name: user.name,
    title: user.title,
    email: user.email,
    timezone: user.tz || user.timezone
  }
  this.timezones = timezones.filter(tz => tz.indexOf('America') > -1)
  let initialTimezone = user.tz || user.timezone

  this.showError = false
  this.errorMessage = ''
  this.saving = false

  this.saveInfo = function(info) {
    this.saving = true
    this.showError = false

    // only send the diff of info and original user info
    var payload = {}
    if (info.name !== user.name) {
      payload.name = info.name
    }
    if (info.title !== user.title) {
      payload.title = info.title
    }
    if (info.email !== user.email) {
      payload.email = info.email
    }
    if (info.timezone !== initialTimezone) {
      payload.timezone = info.timezone
    }

    adminApi.editUserInfo([user.uuid], payload).then(
      function(result) {
        this.saving = false
        $modalInstance.close(result)
      }.bind(this),
      function(reason) {
        this.showError = true
        this.errorMessage = reason
        this.saving = false
      }.bind(this)
    )
  }
}
